module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 16-794061ad6f556a71e57c794a3d34e0a3.webp";